module.exports = __webpack_public_path__ + "aa333293.svg";